import { Component, OnInit } from '@angular/core';
import { FilterComponentBase } from 'src/app/main/filter-component-base';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-filter-currency',
  templateUrl: './filter-currency.component.html',
  styleUrls: ['./filter-currency.component.scss']
})
export class FilterCurrencyComponent extends FilterComponentBase implements OnInit {

  constructor() { 
    super()
  }

  ngOnInit() {
  }

}
